// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__Jy","cls2":"CreateSocialItemModal-cls2__gg CreateSocialItemModal-cls1__Jy"};